// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/fonts/Rubik-Regular/Rubik-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/fonts/Open-Sans-Regular/open-sans-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/fonts/Open-Sans-Regular/open-sans-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/fonts/Open-Sans-Regular/open-sans-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/fonts/Open-Sans-Regular/open-sans-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/fonts/Open-Sans-Regular/open-sans-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/public/fonts/Open-Sans-Bold/open-sans-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/public/fonts/Open-Sans-Bold/open-sans-bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/public/fonts/Open-Sans-Bold/open-sans-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/public/fonts/Open-Sans-Bold/open-sans-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/public/fonts/Open-Sans-Bold/open-sans-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("/public/fonts/Open-Sans-Semibold/opensans-semibold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("/public/fonts/Open-Sans-Semibold/opensans-semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("/public/fonts/Open-Sans-Semibold/opensans-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("/public/fonts/Open-Sans-Semibold/opensans-semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("/public/fonts/Open-Sans-Semibold/opensans-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("/public/fonts/Rubik/Rubik-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("/public/fonts/Rubik/Rubik-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("/public/fonts/Rubik/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("/public/fonts/Rubik/Rubik-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("/public/fonts/Helvetica/Helvetica.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("/public/fonts/Helvetica/Helvetica.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("/public/fonts/Helvetica/Helvetica.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("/public/fonts/Helvetica//Helvetica.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("/public/fonts/Rubik-Black/Rubik-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("/public/fonts/Rubik-Black/Rubik-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("/public/fonts/Rubik-Black/Rubik-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("/public/fonts/Rubik-Black/Rubik-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("/public/fonts/Rubik-Black/Rubik-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("/public/fonts/Rubik-Bold/Rubik-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("/public/fonts/Rubik-Bold/Rubik-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("/public/fonts/Rubik-Bold/Rubik-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("/public/fonts/Rubik-Bold/Rubik-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("/public/fonts/Rubik-Bold/Rubik-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("/public/fonts/Rubik-Regular/Rubik-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("/public/fonts/Rubik-Regular/Rubik-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("/public/fonts/Rubik-Regular/Rubik-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("/public/fonts/Rubik-Regular/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("/public/fonts/Rubik-Light/Rubik-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("/public/fonts/Rubik-Light/Rubik-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("/public/fonts/Rubik-Light/Rubik-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("/public/fonts/Rubik-Light/Rubik-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("/public/fonts/Rubik-Light/Rubik-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("/public/fonts/Rubik-Medium/Rubik-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("/public/fonts/Rubik-Medium/Rubik-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("/public/fonts/Rubik-Medium/Rubik-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("/public/fonts/Rubik-Medium/Rubik-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("/public/fonts/Rubik-Medium/Rubik-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("/public/fonts/Avenir-Roman/AvenirLTStd-Roman.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("/public/fonts/Avenir-Roman/AvenirLTStd-Roman.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("/public/fonts/Avenir-Roman/AvenirLTStd-Roman.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("/public/fonts/Avenir-Roman/AvenirLTStd-Roman.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("/public/fonts/Montserrat/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("/public/fonts/Montserrat/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("/public/fonts/Montserrat/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("/public/fonts/Montserrat/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#Gotham-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "#Gotham-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#Gotham-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "#Gotham-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "#Gotham-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___, { hash: "#Rubik" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "#Helvetica" });
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___, { hash: "#Rubik-Black" });
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___, { hash: "#Rubik-Bold" });
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___, { hash: "#Rubik-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___, { hash: "#Rubik-Light" });
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___, { hash: "#Rubik-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___, { hash: "#Avenir-Roman" });
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

#app {
  margin: 0 auto;
}
/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
  font-family: Rubik-Regular, sans-serif
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}
input::-ms-clear, [type="text"]::-ms-clear { /* 1 */
    overflow: visible;
    display: none;
}
/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}
.donut-chart-tooltip {
    min-width: 60px;
    min-height: 60px;
    border-radius: 50%;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);
    -moz-box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);
    box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

@font-face {
  font-family: 'Proxima-Nova-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('embedded-opentype');
  font-style: normal;
}

@font-face {
  font-family: 'Rubik-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'Open-Sans-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'Proxima-Nova-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('svg'),
  url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('embedded-opentype');
  font-style: normal;
}

@font-face {
  font-family: 'Rubik-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'Helvetica';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format('svg');
  font-style: normal;
  font-weight: normal;
}
@font-face {
    font-family: 'Rubik-Black';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_45___}) format('svg');
    font-style: normal;
    font-weight: normal;
}

@font-face {
    font-family: 'Rubik-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_50___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format('svg');
    font-style: normal;
    font-weight: normal;
}

@font-face {
    font-family: 'Rubik-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format('svg');
    font-style: normal;
    font-weight: normal;
}

@font-face {
    font-family: 'Rubik-Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_60___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_61___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_62___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_63___}) format('svg');
    font-style: normal;
    font-weight: normal;
}

@font-face {
    font-family: 'Rubik-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_66___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_67___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_68___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_69___}) format('svg');
    font-style: normal;
    font-weight: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
  font-family: 'Helvetica';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format('truetype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format('svg');
  font-style: normal;
  font-weight: normal;
}

@font-face {
    font-family: 'Avenir-Roman';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_71___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_72___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_73___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_74___}) format('svg');
    font-style: normal;
    font-weight: normal;
}
@font-face {
    font-family: 'Montserrat-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_75___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_75___}) format('truetype');
    font-style: normal;
    font-weight: normal;
}
@font-face {
    font-family: 'Montserrat-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_76___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_76___}) format('truetype');
    font-style: normal;
    font-weight: 500;
}
@font-face {
    font-family: 'Montserrat-SemiBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_77___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_77___}) format('truetype');
    font-style: normal;
    font-weight: normal;
}
@font-face {
    font-family: 'Montserrat-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_78___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_78___}) format('truetype');
    font-style: normal;
    font-weight: normal;
}

.point-percentage {
    font-family: Rubik-Regular;
    color: #000000;
    font-size: 18px;
}
.drop-back{
    opacity: .2;
    z-index: 1050;
}

input[type="file"]{
    font-size: 0px;
}

input[type=time]::-webkit-datetime-edit-ampm-field {
    display: none;
}

.Toastify__toast{
  border-radius: 6px !important;
}

.dropdown-menu{
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;

}

/* Challenges->Completed tab->Year dropdown */
.yearDropdownCustomChallenge{
  button{
    background-color: rgba(156, 156, 156, 0.1);
    border: none;
    color: #005C87;
  }
  :hover{
    background-color: rgba(156, 156, 156, 0.1);
    color: #005C87;
  }
  :focus{
    background-color: rgba(156, 156, 156, 0.1);
    color: #005C87;
  }
}

.adventureTabActive{
  border-bottom: 3px solid rgb(13, 66, 112);
}

.montecarlo-regular {
  font-family: "MonteCarlo", cursive;
  font-weight: 400;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./src/css/normalize.css"],"names":[],"mappings":"AAAA,2EAA2E;;AAE3E;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,iBAAiB,EAAE,MAAM;EACzB,8BAA8B,EAAE,MAAM;AACxC;;AAEA;EACE,cAAc;AAChB;AACA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,SAAS;EACT;AACF;;AAEA;;;EAGE;;AAEF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,uBAAuB,EAAE,MAAM;EAC/B,SAAS,EAAE,MAAM;EACjB,iBAAiB,EAAE,MAAM;AAC3B;;AAEA;;;EAGE;;AAEF;EACE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE;;AAEF;EACE,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;EAClC,iCAAiC,EAAE,MAAM;AAC3C;;AAEA;;EAEE;;AAEF;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE;;AAEF;;;EAGE,iCAAiC,EAAE,MAAM;EACzC,cAAc,EAAE,MAAM;AACxB;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;;;EAGE;;AAEF;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,eAAe,EAAE,MAAM;EACvB,iBAAiB,EAAE,MAAM;EACzB,SAAS,EAAE,MAAM;AACnB;;AAEA;;;EAGE;;AAEF;QACQ,MAAM;EACZ,iBAAiB;AACnB;AACA,6CAA6C,MAAM;IAC/C,iBAAiB;IACjB,aAAa;AACjB;AACA;;;EAGE;;AAEF;SACS,MAAM;EACb,oBAAoB;AACtB;;AAEA;;EAEE;;AAEF;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE;;AAEF;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE;;AAEF;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE;;AAEF;EACE,8BAA8B;AAChC;;AAEA;;;;;EAKE;;AAEF;EACE,sBAAsB,EAAE,MAAM;EAC9B,cAAc,EAAE,MAAM;EACtB,cAAc,EAAE,MAAM;EACtB,eAAe,EAAE,MAAM;EACvB,UAAU,EAAE,MAAM;EAClB,mBAAmB,EAAE,MAAM;AAC7B;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;;;EAGE;;AAEF;;EAEE,sBAAsB,EAAE,MAAM;EAC9B,UAAU,EAAE,MAAM;AACpB;;AAEA;;EAEE;;AAEF;;EAEE,YAAY;AACd;;AAEA;;;EAGE;;AAEF;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE;;AAEF;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,cAAc;AAChB;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,aAAa;AACf;;AAEA;;EAEE;;AAEF;EACE,aAAa;AACf;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;IAC/C,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,4CAAuE;EACvE;;;;qEAIqG;EACrG,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4CAAyD;EACzD;;;;wDAIwF;EACxF,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6CAA2D;EAC3D;;;;wDAIkF;EAClF,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,6CAAiE;EACjE;;;;sEAI+F;EAC/F,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6CAAkE;EAClE;;;;wDAIyF;EACzF,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,6CAAiD;EACjD;;;wDAGgE;EAChE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6CAAiD;EACjD;;;wDAGoE;EACpE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;IACI,0BAA0B;IAC1B,6CAAqD;IACrD;;;;0DAI0E;IAC1E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6CAAmD;IACnD;;;;0DAIuE;IACvE,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,6CAAyD;IACzD;;;;0DAIgF;IAChF,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,6CAAqD;IACrD;;;;0DAI0E;IAC1E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,6CAAuD;IACvD;;;;0DAI6E;IAC7E,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,oBAAoB;EACpB,6CAAiD;EACjD;;;wDAGgE;EAChE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6CAAiD;EACjD;;;wDAGoE;EACpE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,6CAA4D;IAC5D;;;0DAGkF;IAClF,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iCAAiC;IACjC;+DACyE;IACzE,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC;+DACwE;IACxE,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC;+DAC0E;IAC1E,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B;+DACsE;IACtE,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA,6CAA6C;AAC7C;EACE;IACE,0CAA0C;IAC1C,YAAY;IACZ,cAAc;EAChB;EACA;IACE,0CAA0C;IAC1C,cAAc;EAChB;EACA;IACE,0CAA0C;IAC1C,cAAc;EAChB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n#app {\n  margin: 0 auto;\n}\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n  font-family: Rubik-Regular, sans-serif\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the gray background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\ninput::-ms-clear, [type=\"text\"]::-ms-clear { /* 1 */\n    overflow: visible;\n    display: none;\n}\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n.donut-chart-tooltip {\n    min-width: 60px;\n    min-height: 60px;\n    border-radius: 50%;\n    background-color: #fff;\n    -webkit-box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);\n    -moz-box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);\n    box-shadow: 0px 0px 5px 0px rgba(204,204,204,1);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@font-face {\n  font-family: 'Proxima-Nova-Regular';\n  src: url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.eot');\n  src: url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.woff2') format('woff2'),\n  url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.woff') format('woff'),\n  url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.ttf') format('truetype'),\n  url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.svg#Gotham-Medium') format('svg'),\n  url('/public/fonts/Proxima-Nova-Regular/proxima-nova-regular.eot?#iefix') format('embedded-opentype');\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik-Regular';\n  src: url('/public/fonts/Rubik-Regular/Rubik-Regular.eot');\n  src: url('/public/fonts/Open-Sans-Regular/open-sans-regular.woff2') format('woff2'),\n  url('/public/fonts/Open-Sans-Regular/open-sans-regular.woff') format('woff'),\n  url('/public/fonts/Open-Sans-Regular/open-sans-regular.ttf') format('truetype'),\n  url('/public/fonts/Open-Sans-Regular/open-sans-regular.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Open-Sans-Regular/open-sans-regular.svg#Gotham-Medium') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Open-Sans-Bold';\n  src: url('/public/fonts/Open-Sans-Bold/open-sans-bold.eot');\n  src: url('/public/fonts/Open-Sans-Bold/open-sans-bold.woff2') format('woff2'),\n  url('/public/fonts/Open-Sans-Bold/open-sans-bold.woff') format('woff'),\n  url('/public/fonts/Open-Sans-Bold/open-sans-bold.ttf') format('truetype'),\n  url('/public/fonts/Open-Sans-Bold/open-sans-bold.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Open-Sans-Bold/open-sans-bold.svg#Gotham-Medium') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Proxima-Nova-Bold';\n  src: url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.eot');\n  src: url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.woff2') format('woff2'),\n  url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.woff') format('woff'),\n  url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.ttf') format('truetype'),\n  url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.svg#Gotham-Medium') format('svg'),\n  url('/public/fonts/Proxima-Nova-Bold/proxima-nova-bold.eot?#iefix') format('embedded-opentype');\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Rubik-Bold';\n  src: url('/public/fonts/Open-Sans-Semibold/opensans-semibold.svg');\n  src: url('/public/fonts/Open-Sans-Semibold/opensans-semibold.woff2') format('woff2'),\n  url('/public/fonts/Open-Sans-Semibold/opensans-semibold.woff') format('woff'),\n  url('/public/fonts/Open-Sans-Semibold/opensans-semibold.ttf') format('truetype'),\n  url('/public/fonts/Open-Sans-Semibold/opensans-semibold.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Open-Sans-Semibold/opensans-semibold.svg#Gotham-Medium') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('/public/fonts/Rubik/Rubik-Regular.svg');\n  src: url('/public/fonts/Rubik/Rubik-Regular.woff') format('woff'),\n  url('/public/fonts/Rubik/Rubik-Regular.ttf') format('truetype'),\n  url('/public/fonts/Rubik/Rubik-Regular.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Rubik/Rubik-Regular.svg#Rubik') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Helvetica';\n  src: url('/public/fonts/Helvetica/Helvetica.svg');\n  src: url('/public/fonts/Helvetica/Helvetica.woff') format('woff'),\n  url('/public/fonts/Helvetica/Helvetica.ttf') format('truetype'),\n  url('/public/fonts/Helvetica//Helvetica.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Helvetica/Helvetica.svg#Helvetica') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n@font-face {\n    font-family: 'Rubik-Black';\n    src: url('/public/fonts/Rubik-Black/Rubik-Black.svg');\n    src: url('/public/fonts/Rubik-Black/Rubik-Black.woff2') format('woff2'),\n    url('/public/fonts/Rubik-Black/Rubik-Black.woff') format('woff'),\n    url('/public/fonts/Rubik-Black/Rubik-Black.ttf') format('truetype'),\n    url('/public/fonts/Rubik-Black/Rubik-Black.eot?#iefix') format('embedded-opentype'),\n    url('/public/fonts/Rubik-Black/Rubik-Black.svg#Rubik-Black') format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n    font-family: 'Rubik-Bold';\n    src: url('/public/fonts/Rubik-Bold/Rubik-Bold.svg');\n    src: url('/public/fonts/Rubik-Bold/Rubik-Bold.woff2') format('woff2'),\n    url('/public/fonts/Rubik-Bold/Rubik-Bold.woff') format('woff'),\n    url('/public/fonts/Rubik-Bold/Rubik-Bold.ttf') format('truetype'),\n    url('/public/fonts/Rubik-Bold/Rubik-Bold.eot?#iefix') format('embedded-opentype'),\n    url('/public/fonts/Rubik-Bold/Rubik-Bold.svg#Rubik-Bold') format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n    font-family: 'Rubik-Regular';\n    src: url('/public/fonts/Rubik-Regular/Rubik-Regular.svg');\n    src: url('/public/fonts/Rubik-Regular/Rubik-Regular.woff2') format('woff2'),\n    url('/public/fonts/Rubik-Regular/Rubik-Regular.woff') format('woff'),\n    url('/public/fonts/Rubik-Regular/Rubik-Regular.ttf') format('truetype'),\n    url('/public/fonts/Rubik-Regular/Rubik-Regular.eot?#iefix') format('embedded-opentype'),\n    url('/public/fonts/Rubik-Regular/Rubik-Regular.svg#Rubik-Regular') format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n    font-family: 'Rubik-Light';\n    src: url('/public/fonts/Rubik-Light/Rubik-Light.svg');\n    src: url('/public/fonts/Rubik-Light/Rubik-Light.woff2') format('woff2'),\n    url('/public/fonts/Rubik-Light/Rubik-Light.woff') format('woff'),\n    url('/public/fonts/Rubik-Light/Rubik-Light.ttf') format('truetype'),\n    url('/public/fonts/Rubik-Light/Rubik-Light.eot?#iefix') format('embedded-opentype'),\n    url('/public/fonts/Rubik-Light/Rubik-Light.svg#Rubik-Light') format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n    font-family: 'Rubik-Medium';\n    src: url('/public/fonts/Rubik-Medium/Rubik-Medium.svg');\n    src: url('/public/fonts/Rubik-Medium/Rubik-Medium.woff2') format('woff2'),\n    url('/public/fonts/Rubik-Medium/Rubik-Medium.woff') format('woff'),\n    url('/public/fonts/Rubik-Medium/Rubik-Medium.ttf') format('truetype'),\n    url('/public/fonts/Rubik-Medium/Rubik-Medium.eot?#iefix') format('embedded-opentype'),\n    url('/public/fonts/Rubik-Medium/Rubik-Medium.svg#Rubik-Medium') format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  src: url('/public/fonts/Rubik/Rubik-Regular.svg');\n  src: url('/public/fonts/Rubik/Rubik-Regular.woff') format('woff'),\n  url('/public/fonts/Rubik/Rubik-Regular.ttf') format('truetype'),\n  url('/public/fonts/Rubik/Rubik-Regular.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Rubik/Rubik-Regular.svg#Rubik') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n  font-family: 'Helvetica';\n  src: url('/public/fonts/Helvetica/Helvetica.svg');\n  src: url('/public/fonts/Helvetica/Helvetica.woff') format('woff'),\n  url('/public/fonts/Helvetica/Helvetica.ttf') format('truetype'),\n  url('/public/fonts/Helvetica//Helvetica.eot?#iefix') format('embedded-opentype'),\n  url('/public/fonts/Helvetica/Helvetica.svg#Helvetica') format('svg');\n  font-style: normal;\n  font-weight: normal;\n}\n\n@font-face {\n    font-family: 'Avenir-Roman';\n    src: url(\"/public/fonts/Avenir-Roman/AvenirLTStd-Roman.svg\");\n    src: url(\"/public/fonts/Avenir-Roman/AvenirLTStd-Roman.woff\") format('woff'),\n    url('/public/fonts/Avenir-Roman/AvenirLTStd-Roman.ttf') format('truetype'),\n    url(\"/public/fonts/Avenir-Roman/AvenirLTStd-Roman.eot?#iefix\") format('embedded-opentype'),\n    url(\"/public/fonts/Avenir-Roman/AvenirLTStd-Roman.svg#Avenir-Roman\") format('svg');\n    font-style: normal;\n    font-weight: normal;\n}\n@font-face {\n    font-family: 'Montserrat-Regular';\n    src: url(\"/public/fonts/Montserrat/Montserrat-Regular.ttf\"),\n    url('/public/fonts/Montserrat/Montserrat-Regular.ttf') format('truetype');\n    font-style: normal;\n    font-weight: normal;\n}\n@font-face {\n    font-family: 'Montserrat-Medium';\n    src: url(\"/public/fonts/Montserrat/Montserrat-Medium.ttf\"),\n    url('/public/fonts/Montserrat/Montserrat-Medium.ttf') format('truetype');\n    font-style: normal;\n    font-weight: 500;\n}\n@font-face {\n    font-family: 'Montserrat-SemiBold';\n    src: url(\"/public/fonts/Montserrat/Montserrat-SemiBold.ttf\"),\n    url('/public/fonts/Montserrat/Montserrat-SemiBold.ttf') format('truetype');\n    font-style: normal;\n    font-weight: normal;\n}\n@font-face {\n    font-family: 'Montserrat-Bold';\n    src: url(\"/public/fonts/Montserrat/Montserrat-Bold.ttf\"),\n    url('/public/fonts/Montserrat/Montserrat-Bold.ttf') format('truetype');\n    font-style: normal;\n    font-weight: normal;\n}\n\n.point-percentage {\n    font-family: Rubik-Regular;\n    color: #000000;\n    font-size: 18px;\n}\n.drop-back{\n    opacity: .2;\n    z-index: 1050;\n}\n\ninput[type=\"file\"]{\n    font-size: 0px;\n}\n\ninput[type=time]::-webkit-datetime-edit-ampm-field {\n    display: none;\n}\n\n.Toastify__toast{\n  border-radius: 6px !important;\n}\n\n.dropdown-menu{\n  max-height: 300px;\n  overflow-x: hidden;\n  overflow-y: auto;\n\n}\n\n/* Challenges->Completed tab->Year dropdown */\n.yearDropdownCustomChallenge{\n  button{\n    background-color: rgba(156, 156, 156, 0.1);\n    border: none;\n    color: #005C87;\n  }\n  :hover{\n    background-color: rgba(156, 156, 156, 0.1);\n    color: #005C87;\n  }\n  :focus{\n    background-color: rgba(156, 156, 156, 0.1);\n    color: #005C87;\n  }\n}\n\n.adventureTabActive{\n  border-bottom: 3px solid rgb(13, 66, 112);\n}\n\n.montecarlo-regular {\n  font-family: \"MonteCarlo\", cursive;\n  font-weight: 400;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
